module.exports = __webpack_public_path__ + "static/media/teamLunchOne.25af03d3.png";